import { render } from "./BannerHome.vue?vue&type=template&id=6e10e9ec&scoped=true"
import script from "./BannerHome.vue?vue&type=script&lang=js"
export * from "./BannerHome.vue?vue&type=script&lang=js"

import "./BannerHome.vue?vue&type=style&index=0&id=6e10e9ec&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e10e9ec"]])

export default __exports__